document.addEventListener("DOMContentLoaded", function () {

    const tocSelectors = [
        "#service-list-toc",
        "#service-provider-list-toc" // ← add more if needed
    ];

    tocSelectors.forEach(selector => {

        const toc = document.querySelector(selector);
        if (!toc) return;

        const tocLinks = toc.querySelectorAll("a");

        tocLinks.forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();

                const target = document.querySelector(this.getAttribute("href"));
                if (!target) return;

                window.scrollTo({
                    top: target.offsetTop - 200,
                    behavior: "smooth"
                });

                // FIXED: remove class from li items (not the ul)
                toc.querySelectorAll("li").forEach(li => {
                    li.classList.remove("current-active-archive");
                });

                this.parentElement.classList.add("current-active-archive");
            });
        });

    });

});
